import { useSearch } from '@tanstack/react-router';
import { PRIVILEGES } from '@stayon/auth-core';
import { can, useAuth } from '@/shared/auth';
import { CleaningBoardPage } from './board/CleaningBoardPage';
import { MyTasksPage } from './my-tasks/MyTasksPage';

/**
 * Reinigung: wer nur eigene Aufgaben bearbeitet, sieht „Meine Aufgaben“ als Tagesplan; wer zuteilt
 * (Leitung, Verwaltung), die Aufgabenliste. Die Woche ist für alle dieselbe. Entscheidend sind die
 * Rechte, nicht der Rollenname.
 */
export function CleaningPage() {
  const { user } = useAuth();
  const search = useSearch({ from: '/_admin/cleaning' });
  const ownWorkOnly =
    can(user, PRIVILEGES.cleaningOwnTaskWork) && !can(user, PRIVILEGES.cleaningAssignmentsManage);
  return ownWorkOnly && search.view !== 'calendar' ? <MyTasksPage /> : <CleaningBoardPage />;
}
